import { FetchPhoneNumbersRequestTypes } from '../actions/PhoneNumbersActions';

// This is the default NorthAm fallback sales number. NOT Invoca
const initialState = {
  bundle: '1 888 482 7768',
  'cms-footer': '1 888 482 7768',
  'cms-middle': '1 888 482 7768',
  'contact-sales-page': '1 888 482 7768',
  'crm-middle': '1 888 482 7768',
  'crmsuite-footer': '1 888 482 7768',
  'crmsuite-middle': '1 888 482 7768',
  'marketing-footer': '1 888 482 7768',
  'marketing-middle': '1 888 482 7768',
  'operations-footer': '1 888 482 7768',
  'operations-middle': '1 888 482 7768',
  'sales-footer': '1 888 482 7768',
  'sales-middle': '1 888 482 7768',
  'service-footer': '1 888 482 7768',
  'service-middle': '1 888 482 7768',
  'marketingplus-footer': '1 888 482 7768',
  'marketingplus-middle': '1 888 482 7768'
};
const PhoneNumbers = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchPhoneNumbersRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }
    default:
      return state;
  }
};
export default PhoneNumbers;